<template>
  <div class="tabs">
    <ul>
      <li
        v-for="(tab,index) in tabs"
        :key="index"
        :class="{ 'is-active': tab.isActive }"
        @click="selectTab(tab)"
      >
        <a :href="tab.href">{{ tab.name }}</a>
      </li>
    </ul>

    <div class="tab-content-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabs",
  data() {
    return { tabs: [] };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab: function(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$nav-border: outset 2px rgba(100, 100, 100, 0.1);
.tabs {
  width: 100%;
  font-size: 1rem;
  position: relative;
  ul {
    margin: 0;
    padding: 0;
    li {
      width: 25%;
      height: 55px;
      cursor: pointer;
      min-width: 9rem;
      list-style: none;
      line-height: 3rem;
      font-weight: bold;
      text-align: center;
      margin-right: 1rem;
      padding-left: 0.5rem;
      white-space: nowrap;
      padding-right: 0.5rem;
      display: inline-block;
      background: $light-gray;
      border-left: $nav-border;
      border-top: $nav-border;
      border-right: $nav-border;
      transition: all 0.15s ease-in-out;
      border-top-left-radius: $border-radius;
      border-top-right-radius: $border-radius;
      &:hover,
      &.is-active {
        z-index: 2;
        background-color: #fff;
        > a {
          color: $orange;
        }
      }
      a {
        color: $gray-2;
        text-decoration: none;
        @media (max-width: 768px) {
          font-size: 0.875rem;
        }
        @media (max-width: 414px) {
          font-size: 0.75rem;
        }
      }
    }
  }

  .tab-content-wrapper {
    left: 0;
    z-index: 1;
    width: 100%;
    padding: 1rem;
    border-left: $nav-border;
    border-right: $nav-border;
    border-bottom: $nav-border;
    background-color: #fff;
    border-top-right-radius: $border-radius;
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }
}
</style>